module.exports = __webpack_public_path__ + "static/media/DSS card.0e61697a.png";